import { ZonedDateTimeFactory } from '@csp/csp-common-date-util';
import { ApiOptions, Maybe, Patient, RestOptions, UserId } from '@csp/csp-common-model';
import { getMeta } from '@csp/csp-common-util';
import { toRestOptions } from '@csp/csp-fe-auth';
import { UserRestServiceV1 } from '@csp/dmdp-api-client';
import {
  QUESTIONNAIRE_LAST_MISSED_CHECK_V1,
  UserMetaV1,
  UserV1,
  createLastMissedCheckMetaV1,
} from '@csp/dmdp-api-user-dto';
import { ZonedDateTime } from '@csp/dto';

const getLastQuestionnaireMissedCheckTime = ({ metas: userV1Metas }: UserV1): Maybe<ZonedDateTime> => {
  const metas = userV1Metas as Maybe<UserMetaV1[]>;
  const timestamp = getMeta(metas, QUESTIONNAIRE_LAST_MISSED_CHECK_V1)?.data.timestampIsoDateTime;
  return timestamp ? ZonedDateTimeFactory.fromZonedDateTimeString(timestamp) : undefined;
};

const setLastQuestionnaireMissedTime = async (
  patient: Patient,
  timestamp: string,
  apiOptions: RestOptions,
): Promise<void> => {
  const missedInfo = createLastMissedCheckMetaV1(timestamp);
  return UserRestServiceV1.addOrUpdateMyMeta(toRestOptions(apiOptions), patient.userV1, missedInfo);
};

const clearLastQuestionnaireMissedTime = async (apiOptions: ApiOptions): Promise<void> =>
  UserRestServiceV1.deleteMyMeta(toRestOptions(apiOptions), QUESTIONNAIRE_LAST_MISSED_CHECK_V1);

/**
 * Function is intended to be used with M2M token only.
 */
const setLastQuestionnaireMissedTimeServerOnly = async (
  patient: Patient,
  timestamp: string,
  apiOptions: RestOptions,
): Promise<void> => {
  const missedInfo = createLastMissedCheckMetaV1(timestamp);
  return UserRestServiceV1.addOrUpdateMeta(toRestOptions(apiOptions), patient.userV1, missedInfo);
};

/**
 * Function is intended to be used with M2M token only.
 */
const clearLastQuestionnaireMissedTimeServerOnly = async (apiOptions: ApiOptions, userId: UserId): Promise<void> =>
  UserRestServiceV1.deleteMeta(toRestOptions(apiOptions), userId, QUESTIONNAIRE_LAST_MISSED_CHECK_V1);

export const PatientQuestionnaireMissedCheckMetaService = {
  setLastQuestionnaireMissedTime,
  getLastQuestionnaireMissedCheckTime,
  clearLastQuestionnaireMissedTime,
  setLastQuestionnaireMissedTimeServerOnly,
  clearLastQuestionnaireMissedTimeServerOnly,
};
